import React, { Component } from "react";
import { List, Segment } from "semantic-ui-react";

import PractitionerItem from "./Items/PractitionerItem";
import Pagination from "../../utils/Pagination";

const styles = {
  listItem: {
    display: "flex",
    justifyContent: "space-between"
  },
  font: {
    fontSize: "16px",
    fontWeight: "bold"
  }
};

const options = [
  { key: "1", text: "10 por página", value: 10 },
  { key: "2", text: "20 por página", value: 20 },
  { key: "3", text: "50 por página", value: 50 },
  { key: "4", text: "100 por página", value: 100 }
];

export class PractitionersList extends Component {
  state = { paginatedItems: [], itemsPerPage: 10 };

  onChangePage = e => {
    this.setState({
      paginatedItems: e
    });
  };

  render() {
    const { practitioners } = this.props;
    const { paginatedItems, itemsPerPage } = this.state;
    let listItems = [];
    listItems = paginatedItems.map((practitioner, index) => {
      return (
        <PractitionerItem
          showEditForm={this.props.showEditForm}
          selectedPractitioner={this.props.selectedPractitioner}
          clearPractitionerInfo={this.props.clearPractitionerInfo}
          deletePractitioner={this.props.deletePractitioner}
          practitioner={practitioner}
          onChangeCheckbox={this.props.onChangeCheckbox}
          key={index}
        />
      );
    });
    return (
      <Segment className="listAlign">
        <List verticalAlign="middle" divided size="large">
          {practitioners.length > 0 ? (
            <List.Item className="listItemPadding">
              <List.Content verticalAlign="middle">
                <div style={styles.listItem}>
                  <label style={styles.font}>Nombre completo</label>
                  <div>
                    <label style={styles.font} className="labelAlign">
                      Habilitar
                    </label>
                    <label style={styles.font} className="labelAlign">
                      Borrar
                    </label>
                  </div>
                </div>
              </List.Content>
            </List.Item>
          ) : null}
          {listItems}
        </List>
        <Pagination
          items={practitioners}
          itemsPerPage={itemsPerPage}
          onChangePage={this.onChangePage}
          options={options}
        />
      </Segment>
    );
  }
}

export default PractitionersList;
